import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import TeamMemberCard from '@/common/interfaces/modules/TeamMemberCard';

import TitleIconComponent from '@/components/TitleIcon/TitleIcon.vue';

const TeamMemberCardProps = Vue.extend({
  props: { card: Object as () => TeamMemberCard },
});
@Component({
  components: {
    ResponsiveImage,
    TitleIcon: TitleIconComponent,
  },
})
export default class TeamMemberCardComponent extends TeamMemberCardProps {
  ImageSizesThumbnail: ImageSizes = {
    def: new ImageSize([150, 150]),
    sizes: {
      md: new ImageSize([150, 150]),
    },
  };
}
